<template>
    <div class="plannedActual-popup" v-bind:style="{top: posy + 'px', left: posx + 'px', display: toggled ? 'inline-block' : 'none'}" v-if="toggled">
        <div class="background" v-on:click="Close()"></div>


        <div class="picture" v-bind:style="{ background: (employee !== null ? pic : 'url(../img/default.jpg)')}" style="display:inline-block;"></div>
        <div class="label" style="text-align:center; width: 390px; display:block; line-height:60px; height:60px; margin-top:-63px;">{{ anonMode ? $t('roster.view.anonymousEmployee') : employee.lastName+' '+employee.firstName }}</div>
        <div  v-if="!anonMode" style="text-align:center; font-size: 12px; display:block; line-height:10px; height:10px; color: gray; margin-top: -13px; margin-left: 50px; margin-bottom: 10px;">ID: {{ employee.id }}  <i class="fas fa-copy" v-on:click="CopyEmployeeIdToClipBoard"></i></div>

        <div style="border-bottom:1px solid #ccc; width: 390px; margin-bottom:15px;"></div>


        <div v-if="true || $parent.employeePlannedActual[employee.id].vertrag > 0">
    
            <div class="parent_row" v-if="!$parent.plannedActualCalculationSetting.fullMonth && $parent.plannedActualCalculationSetting.saldoMode == 1">
                <div class="header_row">
                    <div class="left_column pointer">
                        {{$t('roster.view.timePeriod')}}
                    </div>
                    <div class="right_column pointer">
                        {{ $parent.plannedActualCalculationSetting.from.format("DD.MM.")}} - {{$parent.plannedActualCalculationSetting.to.format("DD.MM.")}}
                    </div>
                </div>
            </div>
            <div class="parent_row">
                <div class="balance_row" v-bind:style="{'background-color' : ($parent.employeePlannedActual[employee.id].total > 0) ? 'rgba(229, 28, 80,0.5)' : 'rgba(109, 141, 35,0.5)'}">
                    <div class="left_column pointer">
                        {{ $t('global.ui.sum') }}
                    </div>
                    <div class="right_column pointer">
                        {{ ($parent.employeePlannedActual[employee.id].total/1000/3600).toFixed(2) }} h
                    </div>
                </div>
            </div>
            


            <div class="parent_row">
                <div class="header_row" v-on:click="toggle_soll = !toggle_soll;" v-bind:style="{'border-bottom': (toggle_soll) ? '2px solid black' : 'none' }">
                    <div class="left_column pointer">
                        {{ $t('workBalance.summary.target') }}
                    </div>
                    <div class="right_column pointer">
                        {{ ($parent.employeePlannedActual[employee.id].sumSollWorkTime/1000/3600).toFixed(2) }} h
                    </div>
                </div>

                <div class="child_rows" v-if="toggle_soll">
                    <div style="padding-bottom: 4px; margin-bottom:2px;">
                        <div class="left_column">
                            {{ $t('roster.view.previousMonthTargetPlanningDelta') }}
                        </div>
                        <div class="right_column">
                            {{ (($parent.employeePlannedActual[employee.id].unmodifiedDeltaWorkTime)/1000/3600).toFixed(2) }} h / {{ (($parent.employeePlannedActual[employee.id].deltaWorkTime)/1000/3600).toFixed(2) }} h
                        </div>
                    </div>
                    <div style="padding-bottom: 4px; margin-bottom:2px;">
                        <div class="left_column">
                            {{ $t('roster.view.contractTargetPlanningDelta') }}
                        </div>
                        <div class="right_column">
                            {{ ($parent.employeePlannedActual[employee.id].unmodifiedPlannedWorkTime/1000/3600).toFixed(2) }} h / {{ ($parent.employeePlannedActual[employee.id].sollWorkTime/1000/3600).toFixed(2) }} h
                        </div>
                    </div>
                </div>
            </div>


            

            <div class="parent_row">
                <div class="header_row" v-on:click="toggle_produktiv = !toggle_produktiv;" v-bind:style="{'border-bottom': (toggle_produktiv) ? '2px solid black' : 'none' }">
                    <div class="left_column pointer">
                        {{ $t('store.structure.productive') }}
                    </div>
                    <div class="right_column pointer">
                        {{ ($parent.employeePlannedActual[employee.id].sumWorkTimeProduktiv/1000/3600).toFixed(2) }} h
                    </div>
                </div>

                
                <div class="child_rows" v-if="toggle_produktiv">
                    <div style="padding-bottom: 4px; margin-bottom:2px;">
                        <div class="left_column">
                            {{ $t('roster.view.planRest') }}
                        </div>
                        <div class="right_column">
                            {{ ($parent.employeePlannedActual[employee.id].planTime/1000/3600).toFixed(2) }} h
                        </div>
                    </div>
                    <div style="padding-bottom: 4px; margin-bottom:2px;">
                        <div class="left_column">
                            {{ $t('roster.view.hoursLogged') }}<br/>
                            <small class="text-muted">{{ $t('roster.view.confirmedHours') }}</small><br/>
                            <small class="text-muted">{{ $t('roster.view.unConfirmedHours') }}</small>
                        </div>
                        <div class="right_column"><br/>
                            {{ (($parent.employeePlannedActual[employee.id].istConfirmedTime/1000/3600) + ($parent.employeePlannedActual[employee.id].istUnconfirmedTime/1000/3600)).toFixed(2) }} h<br/>
                            <small class="text-muted">{{ ($parent.employeePlannedActual[employee.id].istConfirmedTime/1000/3600).toFixed(2) }} h</small><br/>
                            <small class="text-muted">{{ ($parent.employeePlannedActual[employee.id].istUnconfirmedTime/1000/3600).toFixed(2) }} h</small>
                        </div>
                    </div>
                </div>
            </div>


            <div class="parent_row">
                <div class="header_row" v-on:click="toggle_unproduktiv = !toggle_unproduktiv;" v-bind:style="{'border-bottom': (toggle_unproduktiv) ? '2px solid black' : 'none' }">
                    <div class="left_column pointer">
                        {{ $t('roster.view.unproductive') }}
                    </div>
                    <div class="right_column pointer">
                        {{ ($parent.employeePlannedActual[employee.id].sumWorkTimeUnproduktiv/1000/3600).toFixed(2) }} h
                    </div>
                </div>

                
                <div class="child_rows" v-if="toggle_unproduktiv">
                    <div style="padding-bottom: 4px; margin-bottom:2px;">
                        <div class="left_column">
                            {{ $t('workBalance.summary.vacation') }}
                        </div>
                        <div class="right_column">
                        {{ ($parent.employeePlannedActual[employee.id].urlaub/1000/3600).toFixed(2) }} h
                        </div>
                    </div>
                    <div style="padding-bottom: 4px; margin-bottom:2px;">
                        <div class="left_column">
                            {{ $t('workBalance.summary.sickLeave') }}
                        </div>
                        <div class="right_column">
                        {{ ($parent.employeePlannedActual[employee.id].krankenstand/1000/3600).toFixed(2) }} h
                        </div>
                    </div>
                    <div style="padding-bottom: 4px; margin-bottom:2px;">
                        <div class="left_column">
                            {{ $t('workBalance.summary.nursingLeave') }}
                        </div>
                        <div class="right_column">
                        {{ ($parent.employeePlannedActual[employee.id].pflegeurlaub/1000/3600).toFixed(2) }} h
                        </div>
                    </div>
                    <div style="padding-bottom: 4px; margin-bottom:2px;">
                        <div class="left_column">
                            {{ $t('workBalance.summary.trainee') }}
                        </div>
                        <div class="right_column">
                        {{ ($parent.employeePlannedActual[employee.id].ausbildung/1000/3600).toFixed(2) }} h
                        </div>
                    </div>
                    <div style="padding-bottom: 4px; margin-bottom:2px;">
                        <div class="left_column">
                            {{ $t('workBalance.summary.sickPay') }}
                        </div>
                        <div class="right_column">
                        {{ ($parent.employeePlannedActual[employee.id].lfz/1000/3600).toFixed(2) }} h
                        </div>
                    </div>
                    <div style="padding-bottom: 4px; margin-bottom:2px;">
                        <div class="left_column">
                            {{ $t('roster.main.other') }}
                        </div>
                        <div class="right_column">
                        {{ ($parent.employeePlannedActual[employee.id].miscWorkTime/1000/3600).toFixed(2) }} h
                        </div>
                    </div>
                    <div style="padding-bottom: 4px; margin-bottom:2px;">
                        <div class="left_column">
                            {{ $t('workBalance.payroll.holidayCompensation') }}
                        </div>
                        <div class="right_column">
                        {{ ($parent.employeePlannedActual[employee.id].ftaTime/1000/3600).toFixed(2) }} h
                        </div>
                    </div>
                </div>
            </div>


            <div class="parent_row">
                <div class="header_row" v-on:click="toggle_ft = !toggle_ft;" v-bind:style="{'border-bottom': (toggle_ft) ? '2px solid black' : 'none' }">
                    <div class="left_column pointer">
                        {{ $t('roster.comp.holidayHours') }}
                    </div>
                    <!-- <div class="right_column pointer">
                        {{ ($parent.employeePlannedActual[employee.id].ftPlanTime/1000/3600 + $parent.employeePlannedActual[employee.id].ftIstConfirmedTime/1000/3600 + $parent.employeePlannedActual[employee.id].ftIstUnconfirmedTime/1000/3600 - $parent.employeePlannedActual[employee.id].ftaTime/1000/3600).toFixed(2) }} h
                    </div> -->
                </div>

                <div class="child_rows" v-if="toggle_ft">
                    <div style="padding-bottom: 4px; margin-bottom:2px;">
                        <div class="left_column">
                            {{ $t('roster.view.currentMonth') }}
                        </div>
                        <div class="right_column">
                            {{ ($parent.employeePlannedActual[employee.id].ftPlanTime/1000/3600 + $parent.employeePlannedActual[employee.id].ftIstConfirmedTime/1000/3600 + $parent.employeePlannedActual[employee.id].ftIstUnconfirmedTime/1000/3600).toFixed(2) }} h
                        </div>
                    </div>

                    <div style="margin-top: 4px; padding-bottom: 4px; margin-bottom:2px;">
                        <div class="left_column">
                            {{ $t('workBalance.payroll.holidayCompensation') }}
                        </div>
                        <div class="right_column">
                            - {{ ($parent.employeePlannedActual[employee.id].ftaTime/1000/3600).toFixed(2) }} h
                        </div>
                    </div>

                    <div style="padding-bottom: 4px; margin-bottom:2px;">
                        <div class="left_column">
                            {{ $t('roster.view.carryOver') }}
                        </div>
                        <div class="right_column">
                            {{ ($parent.employeePlannedActual[employee.id].deltaFtWorkTime/1000/3600).toFixed(2) }} h
                        </div>
                    </div>

                    <div style="padding-bottom: 2px; margin-bottom:1px;">
                        <div class="left_column">
                            <b>{{ $t('roster.view.holidayBalanceAccumulated') }}</b>
                        </div>
                        <div class="right_column">
                            <b>{{ ($parent.employeePlannedActual[employee.id].sumFtWorkTime/1000/3600 + $parent.employeePlannedActual[employee.id].deltaFtWorkTime/1000/3600).toFixed(2) }} h</b>
                        </div>
                    </div>


<!--
                    <div style="padding-bottom: 2px; margin-bottom:1px;" v-for="row in $parent.employeePlannedActual[employee.id].ft_list">
                        <div class="left_column" style="font-size: 10px; color:#555;">
                            {{ row.name }}
                        </div>
                        <div class="right_column" style="font-size: 10px; color:#555;">
                            {{ (row.time / 60).toFixed(2) }} h
                        </div>
                    </div>
                    -->
                </div>
            </div>








        </div>
        <!--
        <div v-if="$parent.employeePlannedActual[employee.id].vertrag <= 0" style="width:100%; text-align:center;color: #e5154f;">
            <strong>Kein Arbeitsvertrag</strong>
        </div>
        -->



    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    export default {
        name: 'plannedActualpopup',
        components: {
        },
        data(){
            return{
                employee: null,

                pic: '',
                toggled: false,
                elRelative: null,
                posx: 0,
                posy: 0,
                xoffset: 0,
                toggle_soll: true,
                toggle_produktiv: true,
                toggle_unproduktiv: true,
                toggle_ft: true,


            }
        },
        created () {
            var view = this;
        },
        destroyed(){
        },
        computed: {
            ...mapGetters(['anonMode'])
        },
        methods: {
            CopyEmployeeIdToClipBoard() {
                navigator.clipboard.writeText(this.employee.id);
                this.$helpers.success(this.$t('global.notifications.success'), this.$t('roster.view.copiedToClipboard'));
            },
            Close(){
                //if($(window.mouse.element).closest('.plannedActual-popup').length > 0) return;
                this.Toggle(false);
            },
            Toggle(val){
                if(val !== undefined || val !== null) {
                    this.toggled = val;
                    return;
                }
                this.toggled = !this.toggled;
            },
            Init(parent, employee, elRelative, xoffset){
                this.employee = employee;


                this.pic = this.GetProfilePictureUrl(employee);
                this.toggled = true;
                this.xoffset = xoffset;
                if(elRelative){
                    this.elRelative = elRelative
                    this.Reposition();
                }
            },
            GetProfilePictureUrl(employee){
                if(this.anonMode || !employee || !employee.employeePicture || !employee.employeePicture.server) return '#ccc no-repeat center/cover  url(../img/default.jpg)';
                var d = new Date();
                return '#ccc no-repeat center/cover  url(' + employee.employeePicture.server + '/api/file?id='+ employee.employeePicture.fileId +'&accessToken='+employee.employeePicture.accessToken +"&thumb=small"+ '&time='+Date.now()+')';
            },
            Reposition(){
                var view = this;
                requestAnimationFrame(function(){
                    if(!view.elRelative) return;
                    var box = view.elRelative.getBoundingClientRect();
                    view.posx = 260;
                    view.posy = box.top - 100;

                    var userselectheight = 620;
                    var heightTotal = window.innerHeight;
                    if(heightTotal - box.top < userselectheight) {
                        view.posy = box.top - (userselectheight - (heightTotal - box.top)) - 100;
                    } else {
                        if(heightTotal < userselectheight) {
                            view.posy = 5;
                        } else {
                            view.posy = box.top - 100;
                        }
                    }
                    view.$forceUpdate();
                });
            },

        },
        mounted() {
            $('html').append(this.$el);
        }
    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>



    .left_column {
        display:inline-block;
        width: 250px;
        text-align:left;
        padding: 0 4px;
    }
    .right_column {
        display:inline-block;
        width: 130px;
        text-align:right;
        padding: 0 4px;
    }
    .parent_row {
        margin-bottom: 10px;
        font-size: 13px;
    }
    .balance_row {
        border-bottom: 6px double #333; 
        padding: 4px 0; 
        margin-bottom:6px; 
        font-weight:1000; 
        cursor: pointer;
    }
    .header_row {
        padding: 4px 0; 
        margin-bottom:6px; 
        font-weight:1000; 
        background-color:#efefef;
        cursor: pointer;
    }
    .pointer {
         cursor: pointer;
    }

    .plannedActual-popup{
        position:fixed;
        display:inline-block;
        max-height: 700px;
        width: 450px;
        border-radius: 0px;
        display:none;
        z-index: 1000;
        background: white;
        box-shadow: 4px 4px 5px 3px rgba(0,0,0,0.2);
        padding: 30px;
        border: 1px solid #a5a5a5;

        top: 120px;
        left: 40px;
    }

     .background {
        position: fixed;
        height: 100vh;
        width: 100vw;
        left: 0;
        right: 0;
        z-index: -1;
        top: 0;
    }


    .picture{
        background-size: 100%;
        height: 60px;
        width: 60px;
        border-radius: 100px;
        box-shadow: inset 0 -1px 0 0px #888;
        display:inline-block;
    }
    .label{
        padding-left: 60px;
        font-size: 24px;
        color: #6d8d23;
        font-family: DistrictProBook;
        font-weight: 700;
        margin-bottom: 5px;
    }





    .fa-stack.cancel{
        cursor: pointer;
        position: absolute;
        top: 6px;
        right: 5px;
        font-size: 10px;
        transform: scale(.8);
    }
    .fa-stack.cancel .fa-circle{
    }
    .fa-stack.cancel .fa-times{
        font-size: 13px;
        transform: translateY(3px);
    }


</style>
